export default __webpack_public_path__ + "static/media/P-031.5c60328f.png";